const MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

function parseIsoDate(iso: string): {
  day: number;
  month: number;
  year: number;
} {
  const parts = iso.split("-").map(Number);
  const year = parts[0] ?? 0;
  const month = parts[1] ?? 1;
  const day = parts[2] ?? 1;
  return { day, month: month - 1, year };
}

/** "09 / 09 / 2026" */
export function formatDateSlashes(iso: string): string {
  const { day, month, year } = parseIsoDate(iso);
  return `${String(day).padStart(2, "0")} / ${String(month + 1).padStart(2, "0")} / ${year}`;
}

/** "09/09/26" */
export function formatDateShortSlash(iso: string): string {
  const { day, month, year } = parseIsoDate(iso);
  return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(2, "0")}/${String(year).slice(2)}`;
}

/** "01/10/26 - 07/10/2026" */
export function formatPeriodShort(startIso: string, endIso: string): string {
  const start = parseIsoDate(startIso);
  const end = parseIsoDate(endIso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(start.day)}/${pad(start.month + 1)}/${String(start.year).slice(2)} - ${pad(end.day)}/${pad(end.month + 1)}/${end.year}`;
}

/** "2 s/d. 8 September 2026" (or "28 Agustus s/d. 3 September 2026" across months) */
export function formatPeriodLong(startIso: string, endIso: string): string {
  const start = parseIsoDate(startIso);
  const end = parseIsoDate(endIso);
  if (start.month === end.month && start.year === end.year) {
    return `${start.day} s/d. ${end.day} ${MONTHS[end.month]} ${end.year}`;
  }
  if (start.year === end.year) {
    return `${start.day} ${MONTHS[start.month]} s/d. ${end.day} ${MONTHS[end.month]} ${end.year}`;
  }
  return `${start.day} ${MONTHS[start.month]} ${start.year} s/d. ${end.day} ${MONTHS[end.month]} ${end.year}`;
}
